import type { GroupChannel, SendbirdGroupChat } from "@sendbird/chat/groupChannel";
import useSendbirdStateContext from "@sendbird/uikit-react/useSendbirdStateContext";
import { useQuery } from "@tanstack/react-query";

const CHANNEL_QUERY_KEY = "attention-channel";

export interface ChannelMentee {
  channel: GroupChannel | null;
  currentUserId: string;
  menteeId: string | null;
  name: string;
  avatarUrl: string | null;
  isLoading: boolean;
}

export function useChannelMentee(channelUrl: string): ChannelMentee {
  const store = useSendbirdStateContext();
  const currentUserId = store.config.userId;
  const sdk: SendbirdGroupChat | undefined = store?.stores?.sdkStore?.sdk;

  const { data: channel = null, isLoading } = useQuery({
    queryKey: [CHANNEL_QUERY_KEY, channelUrl],
    queryFn: () => {
      if (!sdk) throw new Error("Sendbird SDK not ready");
      return sdk.groupChannel.getChannel(channelUrl);
    },
    enabled: Boolean(sdk?.groupChannel) && channelUrl.length > 0,
  });

  const teen = channel?.members?.find(
    (member) => member.userId !== currentUserId,
  );

  return {
    channel,
    currentUserId,
    menteeId: teen?.userId ?? null,
    name: teen?.nickname || teen?.userId || "",
    avatarUrl: teen?.profileUrl ?? null,
    isLoading,
  };
}
